import $ from 'jquery';

/**
 * Functionality to allow users to opt-out of the institution field, bypassing it.
 * (BERA want to encourage people to fill it in as much as possible, but not everyone has one)
 */
class InstitutionOptOut {
    constructor () {
        let $addressLabels;
        const $optOutInput         = $('.js-opt-out-field');
        this.$optOutAddressFields  = $('.js-opt-out-container');
        this.$institutionNotListed = $('.js-institution-not-listed');
        this.$institutionField     = $('.js-institution-field');
        this.$institutionInput     = this.$institutionField.find('input');
        this.$form                 = this.$optOutAddressFields.closest('form');

        // Show the field if Postcode anywhere fills it in.
        this.$institutionInput.on('change', $.proxy(this.fieldChange, this));

        // Show / Hide work address depending on opt-out checkbox state
        if ($optOutInput.length) {
            $optOutInput.on('change', function() {
                const $wrapper                 = $(this).closest('.js-work-address-container');
                const $workAddress             = $(this).closest('.js-institution-opt-out').next('.js-opt-out-container');
                const $thisOptOutAddressFields = $workAddress.find('input');

                if ($(this).is(':checked')) {
                    $workAddress.hide();
                    $thisOptOutAddressFields.val('N/A');
                    $wrapper.find('.js-institution-not-listed').show();
                }
                else {
                    // $workAddress.show();
                }
            });
        }

        // Add required icons to fields
        if (this.$optOutAddressFields.length) {
            // Find address labels
            $addressLabels = this.$optOutAddressFields.find('.js-address-field.js-required label');

            // Add *
            $addressLabels.append('<span class="o-form__required-icon js-required-icon">(Required)</span>');

            // Show the field if it has a value already (e.g. if you're editing your profile).
            this.$institutionInput.each(function() {
                if ($(this).val()) {
                    // Get the container.
                    const $wrapper = $(this).closest('.js-work-address-container').find('.js-opt-out-container');

                    // Show the field.
                    $wrapper.removeClass('u-hidden').show();
                }
            });
        }

        // Show / Hide work address depending on opt-out checkbox state
        if (this.$institutionNotListed.length) {
            this.$institutionNotListed.on('click', function() {
                const $wrapper = $(this).closest('.js-work-address-container').find('.js-opt-out-container');

                // Show the field.
                $wrapper.removeClass('u-hidden').show();

                // Make the field editable and focus on it.
                $wrapper.find('input').val('').removeAttr('readonly').focus();

                // Hide the button.
                $(this).hide();
            });
        }

        // Show all the hidden fields on form submission (for validation).
        this.$form.find('[type=submit]').on('click', () => {
            this.$optOutAddressFields.show();
        });
    }

    fieldChange (e) {
        const $elem  = $(e.currentTarget);
        const $value = $elem.val();

        if ($value !== '' && $value !== 'N/A') {
            // Show the address fields.
            $elem.closest(this.$optOutAddressFields).show();

            // Hide the button.
            $elem.closest('.js-work-address-container').find(this.$institutionNotListed).hide();
        }
    }
}

export default InstitutionOptOut;
